export function shouldIgnoreRowSelect(event) {
    return Boolean(event.target.closest(
        'a, button, input, select, textarea, label, [role="button"], .cell_edit',
    ));
}

export function toggleRowSelected(event, setSelected) {
    if (shouldIgnoreRowSelect(event)) {
        return;
    }
    setSelected((prev) => !prev);
}

export function getPortfolioRowClassName(selected) {
    return selected ? 'portfolio-table-row portfolio-row-selected' : 'portfolio-table-row';
}
